/**
 * price-filter-fix.js — Tout Pour Le Barbecue
 *
 * Corrige le filtre de prix des pages de collection, sur deux points.
 *
 * ---------------------------------------------------------------------------
 * 1. LE FILTRE NE FILTRAIT RIEN  (le défaut sérieux)
 *
 * Le curseur travaille en centimes : sa plage vient de `filter.range_max`, soit
 * 26490 pour une collection qui plafonne à 264,90 €. Au clic sur le bouton, le
 * thème reprend telles quelles les valeurs des champs cachés et les place dans
 * l'URL — alors que Shopify attend des **euros** dans `filter.v.price.gte/lte`.
 *
 * Un curseur réglé sur « 50 à 200 € » produisait donc :
 *     ?filter.v.price.gte=5000&filter.v.price.lte=20000
 * c'est-à-dire « entre 5 000 € et 20 000 € » → **0 produit**, une page vide.
 * Et une borne haute seule laissait passer tout le catalogue.
 *
 * Mesuré le 04/09/2026 sur /collections/planches-a-decouper (40 produits) :
 *     gte=5000&lte=20000  (envoyé)  ->  0 produit
 *     gte=50&lte=200      (attendu) -> 27 produits
 *
 * Correction : les champs cachés sont convertis en euros juste avant que le
 * thème ne les lise, puis remis en centimes au tour de boucle suivant pour que
 * le curseur reste cohérent.
 *
 * ---------------------------------------------------------------------------
 * 2. L'ÉTIQUETTE AFFICHAIT DES CENTIMES
 *
 * Le handler livré par Kalles écrit la valeur brute suivie d'un « € » :
 *
 *     _this.find(inputs[handle]).html(Math.round(value_curent) + ' €')
 *
 * L'étiquette affichait donc « 5000 € » là où l'utilisateur avait choisi 50 €.
 *
 * Une rustine posée vers le 19/06/2026 directement dans facets.min.js plafonnait
 * l'affichage à `data-display-max` :
 *
 *     var x=Math.round(a), m=parseInt(s.data("display-max"));
 *     e.find(F[i]).html((i===1 && m && x>m ? m : x) + " €")
 *
 * Elle compare des centimes (x) à des euros (m) : le plafond est presque toujours
 * atteint, et l'étiquette haute restait **figée** sur la valeur maximale. Elle ne
 * traitait par ailleurs que la borne haute (i===1), la borne basse continuant
 * d'afficher des centimes.
 *
 * Correction : notre handler est attaché après celui du thème. Les deux tournent
 * dans le même tour de boucle, donc le navigateur ne peint que notre valeur —
 * pas de scintillement. Les montants passent par formatMoney, lui-même corrigé
 * par money-format-fix.js : l'affichage est identique au reste du site.
 *
 * ---------------------------------------------------------------------------
 * POURQUOI UN FICHIER À NOUS
 * facets.min.js et sections/facets.liquid sont livrés par Kalles : une mise à
 * jour les écraserait. Ce fichier survit. Voir _docs/theme/retouches-maison.md.
 */
(function () {
  'use strict';

  var SLIDER = '.t4s-price_steps_slider';
  var BOUTON = '.t4s-price_slider_btn';
  var MARQUEUR = '__tplbPriceFix';

  /* Les deux étiquettes, dans l'ordre des poignées de noUiSlider. */
  var ETIQUETTES = ['.t4s-price_label .t4s-from', '.t4s-price_label .t4s-to'];
  var CHAMPS = ['.t4s-min_price', '.t4s-max_price'];

  function enEuros(centimes) {
    var valeur = Math.round(Number(centimes) || 0);
    var devise = window.T4SThemeSP && T4SThemeSP.Currency;

    if (devise && typeof devise.formatMoney === 'function') {
      return devise.formatMoney(valeur);
    }
    /* Repli si la devise du thème n'est pas encore prête. */
    return (valeur / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* Le bloc qui porte les étiquettes et les champs cachés du filtre. */
  function blocDe(element) {
    return element.closest('.t4s-price_slider_wrapper') || document;
  }

  function ecrire(slider, indice, centimes) {
    var cible = blocDe(slider).querySelector(ETIQUETTES[indice]);
    if (cible) cible.textContent = enEuros(centimes);
  }

  /* Étiquettes du rendu Liquid : elles affichent le maximum des produits de la
     page courante, pas la borne réelle du filtre. On les réaligne sur les champs
     cachés, qui font foi. */
  function corrigerAuChargement(slider) {
    var bloc = blocDe(slider);

    CHAMPS.forEach(function (selecteur, indice) {
      var champ = bloc.querySelector(selecteur);
      if (champ) ecrire(slider, indice, champ.value);
    });
  }

  function equiper(slider) {
    if (!slider || slider[MARQUEUR] || !slider.noUiSlider) return;
    slider[MARQUEUR] = true;

    /* Ajouté après le handler du thème : c'est notre valeur qui reste. */
    slider.noUiSlider.on('update', function (valeurs, poignee) {
      ecrire(slider, poignee, parseInt(valeurs[poignee], 10));
    });

    corrigerAuChargement(slider);
  }

  function balayer() {
    [].slice.call(document.querySelectorAll(SLIDER)).forEach(equiper);
  }

  /* --- Conversion des bornes envoyées à Shopify ------------------------------
     Le thème lit les champs cachés dans son handler de clic, qui est délégué et
     s'exécute donc en phase de bouillonnement. En écoutant le clic en phase de
     capture, nous passons avant lui. */

  function convertirAvantEnvoi(evenement) {
    var bouton = evenement.target && evenement.target.closest
      ? evenement.target.closest(BOUTON)
      : null;

    if (!bouton) return;

    var bloc = blocDe(bouton);
    var restaurations = [];

    CHAMPS.forEach(function (selecteur) {
      var champ = bloc.querySelector(selecteur);
      if (!champ) return;

      var centimes = Math.round(Number(champ.value) || 0);
      restaurations.push([champ, champ.value]);
      champ.value = (centimes / 100).toFixed(2);
    });

    /* Le thème a lu les valeurs pendant le bouillonnement : on rend au curseur
       les centimes qu'il attend, pour le cas où la page ne serait pas rechargée. */
    setTimeout(function () {
      restaurations.forEach(function (paire) {
        paire[0].value = paire[1];
      });
    }, 0);
  }

  /* Le panneau de filtres est rechargé en AJAX à chaque filtrage : le curseur est
     alors recréé, et notre handler doit être réinstallé. */
  function surveiller() {
    if (!window.MutationObserver) return;

    new MutationObserver(function () {
      balayer();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function demarrer() {
    document.addEventListener('click', convertirAvantEnvoi, true);
    balayer();
    surveiller();

    /* Le curseur peut être créé après nous : quelques passes de rattrapage. */
    var essais = 0;
    var reprise = setInterval(function () {
      balayer();
      if (++essais > 40) clearInterval(reprise);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
